module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Close-8ad98814fc60da172e1aa02ed5a14843.svg";